export const ROUTE_PATHS = {
  login: "/login",
  oddsTransfer: "/odds",
  betting: "/betting",
  report: "/report",
  history: "/history",
  calculate: "/calculate",
  customer: "/customer",
  analysis: "/analysis",
  purchase: "/purchase",
};

export const routeName = {
  loginRoute: ROUTE_PATHS.login,
  oddTransferRoute: ROUTE_PATHS.oddsTransfer,
  bettingRoute: ROUTE_PATHS.betting,
  reportRoute: ROUTE_PATHS.report,
  outstandingRoute: ROUTE_PATHS.history,
  calculateRoute: ROUTE_PATHS.calculate,
  customerRoute: ROUTE_PATHS.customer,
  analysisRoute: ROUTE_PATHS.analysis,
  purchaseRoute: ROUTE_PATHS.purchase,
};
